module.exports = __webpack_public_path__ + "static/media/roundfigure.18f8b23f.jpg";